module.exports = __webpack_public_path__ + "static/media/vilnius-10.d129c560.jpg";